import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';
import { PageBuilderQRCodeModel } from '../page-builder-qrcode.model';

@Component({
    selector: 'abw-page-builder-qrcode-design',
    templateUrl: './page-builder-qrcode-design.component.html',
    styleUrls: ['./page-builder-qrcode-design.component.scss']
})
export class PageBuilderQRCodeDesignComponent {
    @Input() model: PageBuilderQRCodeModel;
    @Input() value: string;
}